const traccarHelper = require('../util/traccar')
const { isInsideTimetable } = require('../util/trips')
const { convertFromUTCDate, getTranslations, convertMS, convertToLocaleTimeString, isClientSide } = require('../util/utils')
const automaticReports = require('../automaticReports')
const jsPDF = require('jspdf')
const { getStyle } = require('../reportStyle')
const { getUserPartner } = require('fleetmap-partners')
const { addTable, headerFromUser } = require('../util/pdfDocument')

async function createDailyUseReport (from, to, userData, traccar) {
  const reportData = []

  const devices = userData.devices

  const sliced = automaticReports.sliceArray(devices, 5)
  let deviceCount = 0
  for (const slice of sliced) {
    const allInOne = await traccarHelper.getAllInOne(traccar, from, to, slice, false, true, true, true, deviceCount, devices.length)

    slice.forEach(d => {
      reportData.push(processDeviceData(allInOne, d, userData))
    })

    deviceCount = deviceCount + slice.length
  }

  return reportData
}

function processDeviceData (allInOne, d, userData) {
  const now = new Date()
  const group = userData.groups.find(g => g.id === d.groupId)

  const deviceTrips = allInOne.trips.filter(t => t.deviceId === d.id)
  const deviceStops = allInOne.stops.filter(t => t.deviceId === d.id)

  userData.weekDays = {
    sunday: true,
    monday: true,
    tuesday: true,
    wednesday: true,
    thursday: true,
    friday: true,
    saturday: true
  }
  userData.dayHours = {
    startTime: '00:00',
    endTime: '12:00'
  }

  const morningTrips = deviceTrips.filter(t => isInsideTimetable(t, userData))
  const morningStart = morningTrips.length && convertFromUTCDate(new Date(morningTrips[0].startTime), userData.user)
  const morningEnd = morningTrips.length && convertFromUTCDate(new Date(morningTrips[morningTrips.length - 1].endTime), userData.user)

  userData.dayHours = {
    startTime: '12:00',
    endTime: '23:59'
  }

  const afternoonTrips = deviceTrips.filter(t => isInsideTimetable(t, userData))

  const afternoonStart = afternoonTrips.length && convertFromUTCDate(new Date(afternoonTrips[0].startTime), userData.user)
  const afternoonEnd = afternoonTrips.length && convertFromUTCDate(new Date(afternoonTrips[afternoonTrips.length - 1].endTime), userData.user)

  console.log('device took', new Date() - now, 'ms')
  return {
    device: d.name,
    licensePlate: d.attributes.license_plate,
    group: group ? group.name : '',
    morningStart,
    morningEnd,
    morningTime: morningStart && morningEnd ? morningEnd.getTime() - morningStart.getTime() : 0,
    lunch: morningEnd && afternoonStart ? afternoonStart.getTime() - morningEnd.getTime() : 0,
    afternoonStart,
    afternoonEnd,
    afternoonTime: afternoonStart && afternoonEnd ? afternoonEnd.getTime() - afternoonStart.getTime() : 0,
    totalTime: morningStart && afternoonEnd ? afternoonEnd.getTime() - morningStart.getTime() : 0,
    totalDrivingTime: deviceTrips.reduce((a, b) => a + b.duration, 0),
    totalStops: deviceStops.length,
    totalDistance: deviceTrips.reduce((a, b) => a + b.distance, 0)
  }
}

async function exportDailyUseReportToPDF (userData, reportData) {
  const translations = getTranslations(userData)
  const timezone = userData.user.attributes.timezone
  const lang = userData.user.attributes.lang || (isClientSide() && navigator.language)

  const headers = [
    translations.report.vehicle,
    'Immatriculation',
    'Groupe',
    'Matin départ',
    'Matin arrêt',
    'Matin temps',
    'Déjeuner',
    'Après-midi départ',
    'Après-midi arrêt',
    'Après-midi temps',
    'Total temps',
    'Total conduit',
    'Total arrêts',
    'Total kms'
  ]

  const data = []
  reportData.forEach(d => {
    const row = [
      d.device,
      d.licensePlate,
      d.group,
      convertToLocaleTimeString(d.morningStart, lang, timezone, userData.user),
      convertToLocaleTimeString(d.morningEnd, lang, timezone, userData.user),
      convertMS(d.morningTime),
      convertMS(d.lunch),
      convertToLocaleTimeString(d.afternoonStart, lang, timezone, userData.user),
      convertToLocaleTimeString(d.afternoonEnd, lang, timezone, userData.user),
      convertMS(d.afternoonTime),
      convertMS(d.totalTime),
      convertMS(d.totalDrivingTime),
      d.totalStops,
      (d.totalDistance / 100).toFixed(1)
    ]
    data.push(row)
  })

  const doc = new jsPDF.jsPDF('l')
  await headerFromUser(doc, 'Rapport de Performance', userData.user)
  const style = getStyle(getUserPartner(userData.user))

  const footValues = []

  doc.setFontSize(11)
  doc.text(new Date(userData.from).toLocaleString() + ' - ' + new Date(userData.to).toLocaleString(), 20, 33)

  style.headerFontSize = 8
  style.bodyFontSize = 7
  const columnStyles = {}
  for (let i = 3; i < 14; i++) {
    columnStyles[i] = { halign: 'right' }
  }
  addTable(doc, headers, data, footValues, style, 40, columnStyles)
  return doc
}

function exportDailyUseReportToExcel (userData, reportData) {

}

exports.createDailyUseReport = createDailyUseReport
exports.exportDailyUseReportToPDF = exportDailyUseReportToPDF
exports.exportDailyUseReportToExcel = exportDailyUseReportToExcel
